import { render, staticRenderFns } from "./lsdocs3.vue?vue&type=template&id=7e823ae0&scoped=true"
import script from "./lsdocs3.vue?vue&type=script&lang=js"
export * from "./lsdocs3.vue?vue&type=script&lang=js"
import style0 from "./lsdocs3.vue?vue&type=style&index=0&id=7e823ae0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e823ae0",
  null
  
)

export default component.exports